import * as _ from 'lodash'
import { Variable, VArray, VBoolean } from 'alkali'
import { VRow } from './extraction'
import StudyContext from './StudyContext'
import UpdateModel from './UpdateModel'
import { isValidRow } from './extraction'
import { diffExtractRows } from 'services/extract/util'
import { extractOutcomes, createExtractRow, toExtractRow } from 'services/extract/generate'
import { ERow } from 'services/extract/types'

const VRowArray = VArray.of(VRow)

/**
 * UpdateModel for Outcome row editing/management
 */
export default class OutcomesModel implements UpdateModel {
	private readonly initial: ERow[]
	readonly outcomes: typeof VRowArray
	readonly diff: Variable
	readonly hasChanges: VBoolean
	readonly isValid: VBoolean
	readonly isSelfValid: VBoolean
	readonly canSubmit: VBoolean
	constructor(private readonly study: StudyContext) {
		this.initial = study.outcomes.map(o => ({
			...toExtractRow('Outcomes', o),
			isPositive: o.isPositive,
			cells: undefined
		}))
		this.outcomes = new VRowArray(_.sortBy(this.study.outcomes, row => (row.name || '').toLowerCase()).map(o => ({
			...createExtractRow('Outcomes', toExtractRow('Outcomes', _.cloneDeep(o))),
			cells: undefined
		})))
		this.diff = this.outcomes.to(current => this.getDiff(current, this.initial))
		this.hasChanges = this.diff.to(d => !!Object.values(d).flat().length)
		this.isSelfValid = this.diff.to(({ added, changed }) => added.concat(changed).every(r => isValidRow(r)))
		this.isValid = this.isSelfValid
	}

	private getDiff(current: ERow[], initial: ERow[]) {
		const removed = _.differenceBy(initial, current, o => o.id)
		const added = _.differenceBy(current, initial, o => o.id)
		const changed = _.without(current, ...added).filter(cur =>
			cur.existing && !_.isEmpty(diffExtractRows(cur, cur.existing))
		)
		return {
			removed,
			added,
			changed
		}
	}

	addOutcome() {
		this.outcomes.push(createExtractRow('Outcomes'))
	}

	generateUpdates(id: number) {
		const { removed, added, changed } = this.diff.valueOf()
		// removed??
		const rows = added.concat(changed)
		const map = _.transform(rows, (map, row) => {
			const studyRow = this.study.rowsById[row.id]
			if (studyRow) map[row.id] = [studyRow]
		}, {})
		const updates = extractOutcomes(rows, map, { id })
		return { updates }
	}
}